"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomTrayTitleSize = exports.BottomTrayModalType = void 0;
var BottomTrayModalType;
(function (BottomTrayModalType) {
    BottomTrayModalType["ARAL"] = "aral";
    BottomTrayModalType["PULSE"] = "pulse";
    BottomTrayModalType["ERROR"] = "error";
    BottomTrayModalType["SUCCESS"] = "success";
})(BottomTrayModalType = exports.BottomTrayModalType || (exports.BottomTrayModalType = {}));
var BottomTrayTitleSize;
(function (BottomTrayTitleSize) {
    BottomTrayTitleSize["SMALL"] = "small";
    BottomTrayTitleSize["DEFAULT"] = "default";
})(BottomTrayTitleSize = exports.BottomTrayTitleSize || (exports.BottomTrayTitleSize = {}));
